// extracted by mini-css-extract-plugin
export default {"btn":"GoToTopBtn_btn__pKx9q"};